;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";import { datadogRum } from '@datadog/browser-rum';
import { nextjsPlugin } from '@datadog/browser-rum-nextjs';

datadogRum.init({
  applicationId: process.env.NEXT_PUBLIC_DATADOG_APP_ID,
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  site: 'ap2.datadoghq.com',
  service: 'headless-nextjs',
  env: process.env.NEXT_PUBLIC_DATADOG_ENV || 'development',
  version: process.env.SENTRY_RELEASE,
  sessionSampleRate: 100, // capture 100% of sessions
  sessionReplaySampleRate: 20, // capture 20% of sessions with replay
  trackResources: true, // Enable Resource tracking
  trackUserInteractions: true, // Enable Action tracking
  trackLongTasks: true, // Enable Long Tasks tracking

  // ----- Recommended Options -----
  allowedTracingUrls: process.env.NEXT_PUBLIC_SERVER_URL, // Enable distributed tracing
  defaultPrivacyLevel: 'mask-user-input', // 'mask-user-input' | 'allow' | 'mask'
  plugins: [nextjsPlugin()],
});
